import { createSlice } from '@reduxjs/toolkit';
import { setInterval, getAllPlans } from './PlannedItemStore';
import moment from 'moment';

export const reducerName = 'calendarState';

const getDayArray = (start, numberOfDays) => {
    let days = [];
    for (let index = 0; index < numberOfDays; index++) {
        const d = moment(start).add(index, 'days').valueOf();
        days.push(d);
    }
    return days;
};

const initialState = {
    start: moment().add(-1, 'days').valueOf(),
    numberOfDays: 30,
    days: getDayArray(moment().add(-1, 'days').valueOf(), 30),
    dayWidth: 90 / 30,
    highLightPersonId: null,
    rowNumberRendered: 0
};

const calendarSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {
        setNumberOfDays: (state, action) => {
            const nod = action.payload;
            const days = getDayArray(state.start, nod);
            state.numberOfDays = nod;
            state.days = days;
            state.dayWidth = 90 / nod;
        },
        setHighLight: (state, action) => {
            state.highLightPersonId = action.payload;
        },
        setStart: (state, action) => {
            const start = action.payload;
            const days = getDayArray(start, state.numberOfDays);
            state.start = start;
            state.days = days;
        },
        setRendered: (state, action) => {
            state.rowNumberRendered = action.payload;
        }
    },
});

export const { setNumberOfDays, setHighLight, setStart, setRendered, setTeamToShow } = calendarSlice.actions;

export const setNumberOfDaysThunk = (nod) => (dispatch, getState) => {
    const start = getState().calendarState.start;
    const days = getDayArray(start, nod);
    dispatch(setNumberOfDays(nod));
    dispatch(setInterval({start: days[0], end: days[nod - 1]}));
    dispatch(getAllPlans());
};

export const setStartThunk = (start) => (dispatch, getState) => {
    const nod = getState().calendarState.numberOfDays;
    const days = getDayArray(start, nod);
    dispatch(setStart(start));
    dispatch(setInterval({start: days[0], end: days[nod - 1]}));
    dispatch(getAllPlans());
};

export default calendarSlice.reducer;